/**
 * @enum {string}
 */
export default {
    Banner: 'Banner',
    Accordion: 'Accordion',
    ImageText: 'Bild mit Text',
    Container: 'Container',
    ComponentRef: 'ComponentReferenceSection'
};
